/**
 *
 * Loader
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import {
  Conditional,
  Dimmer,
  SkeletonLoader,
  SkeletonLine,
  Loader as CoherentLoader,
} from '@cashfree-intl/coherent';

import { isICICIDashboard, isLKDashboard } from 'utils/common';

function Loader({ active, isModal, paragraph }) {
  const isICICI = isICICIDashboard();

  const isLendingKart = isLKDashboard();

  const elem = window.document
    ? document.getElementsByClassName('pusher rightsidebar')
    : [];

  const height = elem && elem[0] ? elem[0].scrollHeight : window.innerHeight;

  return (
    <Conditional if={active}>
      <Conditional if={isICICI || isLendingKart}>
        <Dimmer active={active}>
          <div className="full-loader mb-1" />
          Loading
        </Dimmer>
      </Conditional>
      <Conditional if={!isICICI && !isLendingKart}>
        <Conditional if={!isModal}>
          <div
            className="loader-full"
            style={{
              height,
            }}
          >
            <div className="loader-box-wrapper">
              <div className="box">
                <CoherentLoader active={active} />
              </div>
            </div>
          </div>
        </Conditional>
        <Conditional if={isModal}>
          {/* eslint-disable react/no-array-index-key */}
          {/* eslint-disable-next-line */}
          {Array.apply(null, Array(paragraph)).map((e, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SkeletonLoader key={index}>
              <SkeletonLine />
              <SkeletonLine />
              <SkeletonLine />
              <SkeletonLine />
              <SkeletonLine />
            </SkeletonLoader>
          ))}
        </Conditional>
      </Conditional>
    </Conditional>
  );
}

Loader.propTypes = {
  active: PropTypes.bool.isRequired,
  isModal: PropTypes.bool,
  paragraph: PropTypes.number,
};

export default memo(Loader);
